import { FC } from "react";
import { streakIcon } from "../../../../components/Streak/Svg";
import { StreakStepProps } from "../component/StreakTypes";

export const StreakStep: FC<StreakStepProps> = ({
  step,
  index,
  isActive,
  themeManager,
  pendingStreakImg,
  filledStreakImg,
  checkedUponCompletion,
  isComingSoon
}) => {
  const iconStyles = themeManager.getIconStyles(isActive);
  const imgSrc = isActive
    ? filledStreakImg || streakIcon(true, iconStyles.iconColor)
    : pendingStreakImg || streakIcon(false, iconStyles.iconColor);

  return (
    <div key={index} className={`q_streak_step ${isComingSoon ? "q_streak_step_disable" : isActive ? "q_streak_step_completed" : "q_streak_step_current"}`} >
      <div
        className="q_img_cont"
        style={{ background: iconStyles.background }}
      >
        <img src={imgSrc} alt={`Day ${index + 1}`} />
        {checkedUponCompletion && isActive && (
          <div className="q_streak_check" style={{ background: iconStyles.iconColor }} >
            <svg height={"9"} width={"9"} viewBox="0 0 24 24">
              <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" fill={"#EBFFF7"}></path>
            </svg>
          </div>
        )}
      </div>
      <p
        className={`q_streak_step_title ${isActive ? "q_streak_step_active" : "q_streak_step_disable"
          }`}
          style={themeManager.getStreakDescriptionStyles()}
      >
        {step.title}
      </p>
      <div
        className="q_streak_dot"
        style={{ background: iconStyles.iconColor }}
      />
    </div>
  );
};
